import { graphConfig } from "./authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken: string) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  const data = await fetch(graphConfig.graphMeEndpoint, options);
  const userData = await data.json();
  console.log("userData", userData);

  try {
    const dta2 = await fetch(
      graphConfig.graphMemberOfEndpoint.replace("{userId}", userData.id),
      options
    );
    const groups = await dta2.json();
    console.log("groups", groups);
  } catch (e) {
    console.error(e);
  }

  try {
    const dta2 = await fetch(
      graphConfig.graphJoinedTeamsEndpoint.replace("{userId}", userData.id),
      options
    );
    const teamsGroups = await dta2.json();
    console.log("teamsGroups", teamsGroups);
  } catch (e) {
    console.error(e);
  }

  try {
    const dta2 = await fetch(graphConfig.graphMemberOf, options);
    const members = await dta2.json();
    console.log("members", members);
  } catch (e) {
    console.error(e);
  }
  try {
    const dta2 = await fetch(graphConfig.groupById, options);
    const groupById = await dta2.json();
    console.log("groupById", groupById);
  } catch (e) {
    console.error(e);
  }

  return userData;
}
